import { styled, withStyles } from '@material-ui/core';
import { Checkbox } from '@ds/react-components';

export const DeclarationContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  margin: '12px 0 0 0',
});

export const DeclarationText = styled('p')(({ theme }) => ({
  fontSize: '14px',
  textAlign: 'left',
  maxWidth: '600px',
  wordBreak: 'break-word',
  margin: 0,
}));

export const DeclareCheckbox = withStyles((theme) => ({
  label: {
    color: theme.palette.common.black,
    fontWeight: 'bold',
  },
  root: {
    marginTop: '10px',
  },
}))(Checkbox);
